exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop[data-v-2faa87f0]{max-height:10000px}.slide-leave-active[data-v-2faa87f0]{-webkit-transition:opacity 1s,max-height .4s ease-out;transition:opacity 1s,max-height .4s ease-out}.slide-enter-active[data-v-2faa87f0]{-webkit-transition:opacity 1s,max-height .4s ease-in;transition:opacity 1s,max-height .4s ease-in}.slide-enter[data-v-2faa87f0],.slide-leave-to[data-v-2faa87f0]{overflow:hidden;max-height:0;opacity:0}.slide-enter-to[data-v-2faa87f0],.slide-leave[data-v-2faa87f0]{overflow:hidden}", ""]);

// exports
